import { useState } from "react";
import Requester from "../helpers/Requester";
import App from "../layouts/app";
import clsx from "clsx";
import { Link } from "@inertiajs/react";
import { Trash } from "lucide-react";
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";

export default function Teams({ teams: initialTeams }: { teams: any[] }) {
    const [teams, setTeams] = useState(initialTeams);

    const deleteTeam = (id: number) => {
        const requester = new Requester();

        requester.delete(requester.getUrl(`api/teams/${id}`)).then(() => {
            const updatedTeams = teams.filter(team => team.id !== id);
            setTeams(updatedTeams);
        });
    }

    return (
        <App>
            <PageTitle title="Teams" />
            <ContentWrapper>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg">Teams</h2>
                    <Link href={`/admin/teams/add`} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Team</Link>
                </div>
                <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {teams.map((team) => (
                        <div key={team.id} className="rounded-xl border border-gray-200">
                            <div className="flex items-start justify-between border-b border-gray-200 bg-gray-100 p-5">
                                <div>
                                    <Link href={`/admin/teams/${team.id}`} className="text-lg">
                                        {team.name}
                                    </Link>
                                    <div className="mt-1 text-sm text-gray-500">
                                        {team.players?.length ?? 0} players · {team.achievements?.length ?? 0} achievements
                                    </div>
                                </div>

                                <button
                                    className="text-red-600 hover:text-red-800"
                                    onClick={() => deleteTeam(team.id)}
                                >
                                    <Trash size={16} />
                                </button>
                            </div>

                            <div className="space-y-3 text-sm p-5">
                                <div>
                                    <div className="mb-1 font-medium text-gray-700">Players</div>
                                    <div className="flex flex-wrap gap-2">
                                        {team.players?.slice(0, 4).map((player: any) => (
                                            <Link
                                                key={player.id}
                                                href={`/admin/teams/${team.id}/players/${player.id}`}
                                                className="rounded-full bg-gray-100 px-2.5 py-1 hover:bg-gray-200"
                                            >
                                                {player.nickname}
                                            </Link>
                                        ))}
                                        <Link
                                            href={`/admin/teams/${team.id}/players/add`}
                                            className="rounded-full bg-indigo-50 px-2.5 py-1 text-indigo-600 hover:bg-indigo-100"
                                        >
                                            + Add
                                        </Link>
                                    </div>
                                </div>

                                <div>
                                    <div className="mb-1 font-medium text-gray-700">Achievements</div>
                                    <div className="flex flex-wrap gap-2">
                                        {team.achievements?.slice(0, 3).map((achievement: any) => (
                                            <Link
                                                key={achievement.id}
                                                href={`/admin/teams/${team.id}/achievements/${achievement.id}`}
                                                className="rounded-full bg-amber-50 px-2.5 py-1 hover:bg-amber-100"
                                            >
                                                {achievement.name}
                                            </Link>
                                        ))}
                                        <Link
                                            href={`/admin/teams/${team.id}/achievements/add`}
                                            className="rounded-full bg-indigo-50 px-2.5 py-1 text-indigo-600 hover:bg-indigo-100"
                                        >
                                            + Add
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </ContentWrapper>
        </App >
    )
}